import React, { useState, useEffect } from 'react';
import { X, MessageCircle } from 'lucide-react';
import { useSiteSettings } from '../context/SiteSettingsContext';

const FacebookMessenger = () => {
  const { settings } = useSiteSettings();
  const [showPrompt, setShowPrompt] = useState(false);

  // Get settings with defaults
  const enabled = settings.messengerEnabled !== false;
  const pageId = settings.messengerPageId || 'Bigchiefmotors';
  const greeting = settings.messengerGreeting || "Need help finding your perfect vehicle?";
  const subtext = settings.messengerSubtext || "Chat with us on Messenger - we typically reply within minutes!";

  useEffect(() => {
    if (!enabled) return;
    
    // Show chat prompt after 10 seconds
    const timer = setTimeout(() => {
      setShowPrompt(true);
    }, 10000);

    // Hide prompt after 25 seconds
    const hideTimer = setTimeout(() => {
      setShowPrompt(false);
    }, 25000);

    return () => {
      clearTimeout(timer);
      clearTimeout(hideTimer);
    };
  }, [enabled]);

  const openMessenger = () => {
    window.open(`https://m.me/${pageId}`, '_blank', 'width=400,height=600');
    setShowPrompt(false);
  };

  // Don't render if disabled
  if (!enabled) return null;

  return (
    <>
      {/* Chat Prompt Bubble */}
      {showPrompt && (
        <div className="fixed bottom-24 right-6 z-40 animate-bounce-in">
          <div className="bg-white rounded-2xl shadow-2xl p-4 max-w-[280px] relative">
            <button 
              onClick={() => setShowPrompt(false)}
              className="absolute -top-2 -right-2 w-6 h-6 bg-gray-200 rounded-full flex items-center justify-center hover:bg-gray-300"
            >
              <X size={14} />
            </button>
            <p className="text-gray-800 text-sm font-medium mb-2">👋 {greeting}</p>
            <p className="text-gray-600 text-xs mb-3">{subtext}</p>
            <button 
              onClick={openMessenger}
              className="w-full bg-[#0084ff] hover:bg-[#0073e6] text-white text-sm font-medium py-2 px-4 rounded-lg transition-colors"
            >
              Start Chat
            </button>
          </div>
          <div className="absolute -bottom-2 right-8 w-4 h-4 bg-white transform rotate-45 shadow-lg"></div>
        </div>
      )}

      {/* Messenger Button */}
      <button
        onClick={openMessenger}
        className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-[#0084ff] hover:bg-[#0073e6] rounded-full shadow-lg flex items-center justify-center transition-all duration-300 hover:scale-110 group"
        data-testid="messenger-button"
        aria-label="Chat on Facebook Messenger"
      >
        <MessageCircle size={28} className="text-white" />
        <span className="absolute w-full h-full rounded-full bg-[#0084ff] animate-ping opacity-30"></span>
      </button>

      {/* Online indicator */}
      <div className="fixed bottom-6 right-6 z-50 pointer-events-none">
        <div className="absolute bottom-0 right-0 w-4 h-4 bg-green-500 border-2 border-white rounded-full"></div>
      </div>
    </>
  );
};

export default FacebookMessenger;
